// LoginPage.jsx
import React, { useEffect, useState } from "react";
import {
    App,
    Button,
    Card,
    Checkbox,
    Divider,
    Form,
    Input,
    Typography,
    theme,
    Avatar,
    Space,
    Alert,
    Flex,
    Spin,
} from "antd";
import { MailOutlined, LockOutlined, UserOutlined, ReloadOutlined } from "@ant-design/icons";
import api from "../services/api";
import { useNavigate } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { useLanguage } from "../providers/LanguageProvider";
import { useDispatch } from "react-redux";
import { setCredentials } from "../store/authSlice";
import LangSelect from "src/layouts/MainLayout/LangSelect";
const { Title, Text, Link } = Typography;

export default function LoginWithToken({ onLogin }) {
    const { token } = theme.useToken();
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false);
    const messageApi = App.useApp().message;
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("");
    const [form] = Form.useForm();
    const [error, setError] = useState("");
    const language = useLanguage();
    const activeLang = language.language


    const [loadingResend, setLoadingResend] = useState(false);






    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get("token");
        localStorage.setItem("token", token);
        window.location.href = "/";
    }, []);

    return (<div
        style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        <Spin spinning={true} size="large"></Spin>

    </div>)
}
